export default __webpack_public_path__ + "static/media/Squares_00.2de06c48.png";